<template lang="pug">
.dosage
  .d-flex(v-if="item.editable && item.productItem.medication")
    v-text-field.text-sm.round-xl(v-model.number="item.productItem.medication.dosage_value" placeholder="0" outlined hide-details dense type="number" @input="$emit('changed', item)")
    treatment-dosage-unit-dropdown(:item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed', item); item.editable = false")
  div.clickable(v-else-if="!item.editable && item.productItem.medication && item.productItem.medication.dosage_value")
    span.font-medium.danger500--text(v-if="item.error") {{ item.productItem.medication.dosage_value }} {{ item.productItem.medication.dosage_unit }}
    span(v-else) {{ item.productItem.medication.dosage_value }} {{ item.productItem.medication.dosage_unit }}
</template>

<script>
import TreatmentDosageUnitDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentDosageUnitDropdown.vue'

export default {
  components: {
    TreatmentDosageUnitDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>